import type { FieldMetadata } from '@conform-to/react'
import { getInputProps as getInputPropsBase } from '@conform-to/react'
import { omit } from 'lodash-es'
import type { HTMLInputTypeAttribute } from 'react'

export const getInputProps = <Schema, Options extends { type: HTMLInputTypeAttribute }>(
	metadata: FieldMetadata<Schema, any, any>,
	options: Options & { controlled?: boolean },
) => {
	const base = getInputPropsBase(metadata, { type: options.type as any, ariaAttributes: true })
	const omitted = omit(base, 'id', 'aria-describedby', 'aria-invalid')

	if (!options.controlled) return omitted as typeof base

	return omit(omitted, 'defaultChecked', 'defaultValue') as typeof base
}
